import Api from '@/services/Api'
const dormpath = 'studentdev/dormitory/';

export default {
  get() {
    return Api().get(dormpath + "year");
  },
  post(data) {
    return Api().post(dormpath + "year", data);
  },
  put(data) {
    return Api().put(dormpath + "year", data);
  },
 /* put(data) {
    return Api().put(dormpath + "year", {
      params: {
        id: id
      },
      data: {}
    });
  },*/
  delete(id) {
    return Api().delete(dormpath + "year", {
      params: {
        id: id
      }
    });
  },
  getAll() {
    return Api().get(dormpath + "yearall");
  },



}
